export default __webpack_public_path__ + "locales/es/Common.json?hash=efc7d3d61762622698f573a5462d7076";